import { plugin as storePlugin } from './stores'

import './assets/main.css'
import './assets/index.css'

import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import * as Sentry from "@sentry/vue";

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://62a84cdaa0ea2fd5b20f337f77607b25@o1054175.ingest.us.sentry.io/4508850767855616",
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
            networkDetailAllowUrls: ['https://laravel.heartmanagement.fr/api/login'],
            networkRequestHeaders: ['X-Custom-Header'],
            networkResponseHeaders: ['X-Custom-Header'],
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(storePlugin)
app.use(router)
app.mount('#app')
